import { createSelector } from "reselect";
import moment from "moment";
import { framesResourceSelectors } from "../frames_resource_selectors";

/**
 * Create a selector to get the most recent frames for a set of revisions
 * @param {Object} props
 * @param {array} props.revisions
 * @return {Function} selector
 */
export function createLatestFramesForRevisionsSelector({ revisions }) {
  return createSelector(
    framesResourceSelectors.dataSelector,
    frames => {
      const sortedFrames = Object.values(frames).sort((f1, f2) => {
        return moment(f1.attributes.createdAt).isAfter(f2.attributes.createdAt)
          ? -1
          : 1;
      });

      return revisions.reduce((agg, r) => {
        const filteredFrames = sortedFrames.filter(
          frame => frame.attributes.revisionId == r.id
        );
        agg[r.id] = filteredFrames.length ? filteredFrames[0] : undefined;
        return agg;
      }, {});
    }
  );
}
